import type { Vehicle } from "../../providers/vehiclesProvider";
import { BackButton } from "../../buttons/BackButton";
import { Column } from "../../misc/Column";
import { NameHeader } from "../../misc/NameHeader";
import { Row } from "../../misc/Row";
import { Avatar, Box, Typography } from "@mui/material";
import { useRecordContext, useResourceContext } from "react-admin";
import { VehicleIcon } from "../../icons/VehicleIcon";

export function VehicleDetailsHeader() {
  const vehicle = useRecordContext<Vehicle>();
  const resource = useResourceContext();

  return (
    <Column>
      <Row sx={{ my: "15px" }}>
        <BackButton url={`/drivingSchools/${vehicle.drivingSchoolId}/fleet#${resource}`}>Fuhrpark</BackButton>
      </Row>
      <Row sx={{ mb: "20px" }} spacing="50px" alignItems="start">
        <Row spacing="20px" alignItems="center">
          <Avatar sx={{ p: 0, bgcolor: "action.hover", color: "text.primary" }}>
            <VehicleIcon vehicle={vehicle} />
          </Avatar>
          <Box sx={{ ml: "20px", display: "flex", flexDirection: "column" }}>
            <NameHeader>{vehicle.name}</NameHeader>
            <Typography sx={{ color: "text.secondary", fontSize: "14px", lineHeight: "1.43" }}>
              {vehicle.plateNumber ?? ""}
            </Typography>
          </Box>
        </Row>
      </Row>
    </Column>
  );
}
